(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-hero"] && !Shopify.designMode) return;
  try {
    
  class BlackFridayHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pointerCanHover = window.matchMedia('(hover: hover)').matches;

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.showSlide(Number(button.dataset.slideButton));
          this.restart();
        });
      });

      this.querySelectorAll('[data-copy-code]').forEach((button) => {
        button.addEventListener('click', () => this.copyCode(button));
      });

      this.offersDialog = this.querySelector('[data-offers-dialog]');
      this.openOffersButton = this.querySelector('[data-open-offers]');
      this.closeOffersButton = this.querySelector('[data-close-offers]');
      this.openOffersButton?.addEventListener('click', this.openOffers);
      this.closeOffersButton?.addEventListener('click', this.closeOffers);
      this.offersDialog?.addEventListener('click', this.handleDialogBackdrop);

      if (this.pointerCanHover) {
        this.addEventListener('pointerenter', this.handleEnter);
        this.addEventListener('pointerleave', this.handleLeave);
      }

      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('pointerenter', this.handleEnter);
      this.removeEventListener('pointerleave', this.handleLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      this.openOffersButton?.removeEventListener('click', this.openOffers);
      this.closeOffersButton?.removeEventListener('click', this.closeOffers);
      this.offersDialog?.removeEventListener('click', this.handleDialogBackdrop);
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }

    handleEnter = () => {
      this.dataset.lit = 'true';
    };

    handleLeave = () => {
      delete this.dataset.lit;
      this.start();
    };

    handleFocusIn = () => {
      this.dataset.lit = 'true';
    };

    handleFocusOut = (event) => {
      if (!this.contains(event.relatedTarget)) {
        delete this.dataset.lit;
        this.start();
      }
    };

    handleVisibility = () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };

    openOffers = () => {
      if (this.offersDialog && !this.offersDialog.open) this.offersDialog.showModal();
    };

    closeOffers = () => {
      if (this.offersDialog?.open) this.offersDialog.close();
    };

    handleDialogBackdrop = (event) => {
      if (event.target === this.offersDialog) this.closeOffers();
    };

    async copyCode(button) {
      const code = button.dataset.copyCode;
      const label = button.querySelector('small');
      if (!code || !label) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      window.clearTimeout(button.copyTimer);
      label.textContent = button.dataset.copiedLabel;
      button.copyTimer = window.setTimeout(() => {
        label.textContent = button.dataset.copyLabel;
      }, 1800);
    }

    showSlide(index) {
      if (!this.slides.length) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === this.currentIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    start() {
      if (!this.autoplay || this.reduceMotion || this.slides.length < 2 || this.timer || document.hidden) return;
      this.timer = window.setInterval(() => this.showSlide(this.currentIndex + 1), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('black-friday-hero')) {
    customElements.define('black-friday-hero', BlackFridayHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-product-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.customer-stories:not([data-customer-stories-ready])').forEach((root) => {
      root.dataset.customerStoriesReady = 'true';

      const viewport = root.querySelector('[data-story-viewport]');
      const progress = root.querySelector('[data-story-progress]');

      const syncProgress = () => {
        if (!viewport || !progress) return;

        const scrollableWidth = viewport.scrollWidth - viewport.clientWidth;
        const value = scrollableWidth > 0
          ? (viewport.scrollLeft / scrollableWidth) * 100
          : 0;

        progress.value = value;
        progress.style.setProperty('--story-progress', `${value}%`);
      };

      viewport?.addEventListener('scroll', syncProgress, { passive: true });

      progress?.addEventListener('input', () => {
        if (!viewport) return;

        const scrollableWidth = viewport.scrollWidth - viewport.clientWidth;

        viewport.scrollTo({
          left: (Number(progress.value) / 100) * scrollableWidth,
          behavior: 'auto'
        });
      });

      window.addEventListener('resize', syncProgress);
      syncProgress();

      root.querySelectorAll('.customer-stories__trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const dialog = document.getElementById(trigger.getAttribute('aria-controls'));

          if (dialog) dialog.showModal();
        });
      });

      root.querySelectorAll('.customer-stories__dialog').forEach((dialog) => {
        const close = dialog.querySelector('.customer-stories__close');
        const slides = [...dialog.querySelectorAll('.customer-stories__slide')];
        const previous = dialog.querySelector('.customer-stories__arrow--previous');
        const next = dialog.querySelector('.customer-stories__arrow--next');
        const counter = dialog.querySelector('.customer-stories__counter span');
        let activeIndex = 0;

        const showSlide = (index) => {
          if (!slides.length) return;

          activeIndex = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === activeIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });

          if (counter) counter.textContent = String(activeIndex + 1);
        };

        close.addEventListener('click', () => dialog.close());
        previous?.addEventListener('click', () => showSlide(activeIndex - 1));
        next?.addEventListener('click', () => showSlide(activeIndex + 1));

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });

        dialog.addEventListener('close', () => showSlide(0));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
